module.exports = __webpack_public_path__ + "img/icon-web-home-02.221853bb.png";